import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminMediaEmbedNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('media-embed');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
